import * as moment from "moment/moment";

export class ParticipantCredential {
    id: number;
    user_id: number;
    participant_id: number;

    certification_number: string;
    certification_name: string;
    certification_issuer: string;
    certification_badge: string;
    certification_preview: string;
    certification_file: string;
    certification_issued_on: string;
    certification_authority_type: string;
    certification_authority_status: string;

    blockchain_id: string;

    issued_on: Date = null;

    token: string;

    showSharing: boolean = false;
    selected: boolean = false

    /**
     * constructor
     *
     * @param {ParticipantCredential} init
     */
    public constructor(init?: ParticipantCredential) {
        if (!!init) {
            Object.assign(this, init);

            this.issued_on = moment.utc(this.certification_issued_on).toDate();
        }
    }
}
